const levels: Record<string, number> = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
  none: 4,
};

const logLevelEnv = process.env.REACT_APP_LOG_LEVEL || "info";
const currentLevel = levels[logLevelEnv] !== undefined ? levels[logLevelEnv] : levels.info;

export const logger = {
  debug: (...args: any[]) => {
    if (currentLevel <= levels.debug) {
      console.debug("[DEBUG]", ...args);
    }
  },
  info: (...args: any[]) => {
    if (currentLevel <= levels.info) {
      console.log("[INFO]", ...args);
    }
  },
  warn: (...args: any[]) => {
    if (currentLevel <= levels.warn) {
      console.warn("[WARN]", ...args);
    }
  },
  error: (...args: any[]) => {
    if (currentLevel <= levels.error) {
      console.error("[ERROR]", ...args);
    }
  },
};

export default logger;
